import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/components/spinner/spinner.service";
export class HttpService {
    constructor(http, spinnerService) {
        this.http = http;
        this.spinnerService = spinnerService;
    }
    get(endPoint, params) {
        return this.http
            .get(environment.apiUrl + endPoint, {
            params
        })
            .pipe(catchError(this.handleError));
    }
    post(endPoint, param) {
        return this.http
            .post(environment.apiUrl + endPoint, param)
            .pipe(catchError(this.handleError));
    }
    getExternalApi(endPoint, params) {
        return this.http
            .get(endPoint, {
            params
        })
            .pipe(catchError(this.handleError));
    }
    put(endPoint, param) {
        return this.http
            .put(environment.apiUrl + endPoint, param)
            .pipe(catchError(this.handleError));
    }
    patch(endPoint, param) {
        return this.http
            .patch(environment.apiUrl + endPoint, param)
            .pipe(catchError(this.handleError));
    }
    delete(endPoint, param) {
        return this.http
            .delete(environment.apiUrl + endPoint, param)
            .pipe(catchError(this.handleError));
    }
    deleteWithBody(endPoint, params) {
        return this.http
            .request('delete', environment.apiUrl + endPoint, {
            body: params
        })
            .pipe(catchError(this.handleError));
    }
    // Error handling
    handleError(errorResponse) {
        let errorMessage = '';
        if (errorResponse.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = errorResponse.error.message;
        }
        else {
            // Get server-side error
            errorMessage = `Error Code: ${errorResponse.status}\nMessage: ${errorResponse.message}`;
        }
        if (errorResponse && errorResponse.status === 0) {
            console.log('Error tracking when system is down: ', errorResponse);
            // For errors without status
            Swal.fire({
                title: 'Oops...',
                html: `<h3 class="m-0">Unknown Error</h3>
        <p class="m-0 bold">Something Went Wrong</p>`,
                icon: 'error'
            });
        }
        else if (errorResponse && errorResponse.status < 500) {
            // Mostly for bad request errors
            Swal.fire({
                title: 'Oops...',
                html: `<h3 class="m-0">Error Code ${errorResponse.status}</h3>
        <p class="m-0 bold">${errorResponse.error.error}</p>
        <small class="m-0">(Details: ${errorResponse.error.message})</small>`,
                icon: 'error'
            });
        }
        else {
            console.log('Error tracking when system is down: ', errorResponse);
            // For status 500 errors
            Swal.fire({
                title: 'Oops...',
                html: `<h3 class="m-0">Error Code ${errorResponse.status}</h3>
        <p class="m-0 bold">Something went wrong</p>`,
                icon: 'error'
            });
        }
        return throwError(errorMessage);
    }
}
HttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpService_Factory() { return new HttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.SpinnerService)); }, token: HttpService, providedIn: "root" });
